import { Group, Identifiable, ProjectResource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource } from "./types";

type ResourceResponse = {
  _embedded: {
    projectMembers: LinkedResource<Identifiable<ProjectResource>>[];
  };
};

function linkProjectResourceGroup(httpClient: HttpClient) {
  return (
    group: LinkedResource<Identifiable<Group<Identifiable<ProjectResource>>>>,
  ): Promise<Identifiable<Group<Identifiable<ProjectResource>>>> =>
    httpClient
      .sendHttpRequest<ResourceResponse>({
        endpoint: group._links.resources.href,
        baseUrl: "",
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) => ({
        ...group,
        resources: _embedded.projectMembers,
      }));
}

export { linkProjectResourceGroup };
